import TechnologyForm from "./TechnologyForm.container";

export default TechnologyForm;
